import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/services/authContext';
import { useI18n } from '@/i18n';

/**
 * Only reachable/relevant in live mode — see ProtectedRoute.tsx and
 * authContext.tsx. In demo mode this route still exists but no page ever
 * redirects to it, matching "do not remove existing... demo functionality".
 */
export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <form onSubmit={submit} className="card" style={{ width: 360, padding: 28 }}>
        <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 4 }}>Ugarits Command Center</div>
        <div style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 20 }}>{t('common.live')}</div>

        <label style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>Email</label>
        <input className="text-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} style={{ marginBottom: 12 }} autoFocus />

        <label style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>Password</label>
        <input className="text-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} style={{ marginBottom: 16 }} />

        {error && <div style={{ fontSize: 12, color: 'var(--crit)', marginBottom: 12 }}>{error}</div>}

        <button className="btn-primary" type="submit" disabled={submitting} style={{ width: '100%' }}>
          {submitting ? '…' : 'Log in'}
        </button>
      </form>
    </div>
  );
}
